import React, { useState } from 'react';
import { OpenPopupButton } from './shared/styles';
import { ReactComponent as IconDownload } from 'icons/download-icon.svg';
import useMedia from 'hooks/useMedia';
import Modal from 'components/utility/Modal/Modal';
import ExportRawDataView from './ExportRawDataView';

const ExportRawDataButton: React.FC<any> = (props) => {
  const isSmallScreen = useMedia('(max-width: 40em)');
  const isMobileScreen = useMedia('(max-width: 25em)');
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <OpenPopupButton onClick={(): void => setShowModal(true)}>
        <IconDownload />
        <span>
          {isMobileScreen ? '' : isSmallScreen ? 'Export' : 'Raw Data Export'}
        </span>
      </OpenPopupButton>
      {showModal && (
        <Modal
          isNarrow
          hide={(): void => setShowModal(false)}
          canClickOutside={true}
        >
          <ExportRawDataView
            close={(): void => setShowModal(false)}
            isSmallScreen={isSmallScreen}
            {...props}
          />
        </Modal>
      )}
    </>
  );
};

export default ExportRawDataButton;
